import axios from 'axios'
import { constants } from '@utils/constants'

// Vite: import.meta.env.VITE_API_BASE ?? constants.api.base
const baseURL = constants.api.base

export const api = axios.create({ baseURL })

api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log('api error interceptor', error)
        return Promise.reject(error)
    }
)
